module.exports = __webpack_public_path__ + "static/media/happy4.fc489301.png";